import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const ArrowUpIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill={theme.colors.primary.variant7}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.41076 4.1C6.3214 4.10315 6.23237 4.08763 6.14935 4.05442C6.06633 4.02121 5.99115 3.97105 5.92862 3.90714L4.11576 2.06857C4.10077 2.05302 4.08279 2.04065 4.06291 2.03219C4.04303 2.02374 4.02165 2.01939 4.00005 2.01939C3.97844 2.01939 3.95706 2.02374 3.93718 2.03219C3.9173 2.04065 3.89932 2.05302 3.88433 2.06857L2.07148 3.90714C2.01171 3.9674 1.94061 4.01522 1.86227 4.04786C1.78394 4.0805 1.69991 4.0973 1.61505 4.0973C1.53018 4.0973 1.44616 4.0805 1.36782 4.04786C1.28948 4.01522 1.21838 3.9674 1.15862 3.90714C1.03889 3.7867 0.97168 3.62376 0.97168 3.45393C0.97168 3.28409 1.03889 3.12116 1.15862 3.00071L3.35719 0.757143C3.43906 0.668316 3.53846 0.597421 3.6491 0.54893C3.75975 0.500438 3.87924 0.475403 4.00005 0.475403C4.12085 0.475403 4.24034 0.500438 4.35099 0.54893C4.46163 0.597421 4.56103 0.668316 4.6429 0.757143L6.8929 3.00071C7.01264 3.12116 7.07984 3.28409 7.07984 3.45393C7.07984 3.62376 7.01264 3.7867 6.8929 3.90714C6.83037 3.97105 6.75519 4.02121 6.67217 4.05442C6.58915 4.08763 6.50012 4.10315 6.41076 4.1Z" />
      </svg>
    </Icon>
  );
};

export default ArrowUpIcon;
